import {Component} from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { TranslateService } from '@ngx-translate/core';
import { filter } from "rxjs/operators";

import {environment} from "src/environments/environment";
import { LayoutService } from "./services/layout.service";

@Component({
    selector: "helius-posta",
    templateUrl: "./app.component.html"
})
export class AppComponent {
    // title = "e-Posta";
    sidebarWidth: number;
    useSidebar: boolean = environment.useSidebar;
    isWebViewRoute = false;

    constructor(
        private layoutService: LayoutService,
        public translateService: TranslateService,
        private router: Router
    ) {
      // add multilanges
      translateService.addLangs(['en', 'sq']);
      translateService.setDefaultLang(environment.language || 'en'); // fallback to english

      // change app name && fav-icon
      document.title = environment.appName
      const favIcon: any = document.getElementById('appFavIcon');
      if (!!favIcon) {
        favIcon.href = environment.icon
      }

      // subcribe sidebar width
      layoutService.sidebarWidth.subscribe(data => this.sidebarWidth = data)
      const isDesktop = window.innerWidth > 992
      if (isDesktop) {
        layoutService.toggle()
      }

      this.updateWebViewRoute(this.router.url);
      this.router.events.pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd)
      ).subscribe(e => this.updateWebViewRoute(e.urlAfterRedirects));
    }

    private updateWebViewRoute(url: string): void {
      const path = url.split("?")[0].replace(/\/$/, "") || "/";
      this.isWebViewRoute = path === "/cancel" || path === "/success" || path === "/error";
    }
}
